/*******************************************************
 * COMMON SERVICES
 *******************************************************/

/**
 * Module SERVICES init.
 * add module dependencies here.
 */
angular.module("services", ["ngResource"])

/*
 * WS URL configuration.
 * /data is a mock url pattern : data is retrieved from within the application (/data directory)
 */



/**
     * SharedProperties
     *
     * This service offers a place to share values between controllers.
     */
	.service("SharedProperties", ["Utils", "CONSTANTS", function (Utils, CONSTANTS) {

		"use strict";

		var apiToken, attributes = {};

		return {

			/**
             * Returns the stored token. If no token in memory, tries to retrieve it
             * from session storage.
             * @returns {*}
             */
			getApiToken: function () {
				if (!apiToken) {
					// check whether token is available in session storage
					apiToken = Utils.getStoredObject(CONSTANTS.ATT_API_TOKEN);
					if (!apiToken) {
						apiToken = "";
					}
				}
				return apiToken;
			},

			/**
             * Store api token in memory and in session storage (to help with browser refresh).
             * @param value
             */
			setApiToken: function (value) {
				apiToken = value;
				// also setting the token in session storage in case user hits the F5 dready button
				Utils.storeObject(CONSTANTS.ATT_API_TOKEN, value);
			},

			setAttribute: function (name, object) {
				attributes[name] = object;
				Utils.storeObject(name, object);
			},

			getAttribute: function (name) {
				var retrieved = attributes[name];
				if (retrieved) {
					return retrieved;
				} else {
					return Utils.getStoredObject(name);
				}
			},


		};

	}]);

